/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpsertContractPayloadDto
 */
export interface UpsertContractPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof UpsertContractPayloadDto
     */
    contractId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertContractPayloadDto
     */
    binderId: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertContractPayloadDto
     */
    submissionId: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertContractPayloadDto
     */
    layerId: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertContractPayloadDto
     */
    reinsuredId: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertContractPayloadDto
     */
    brokerId: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertContractPayloadDto
     */
    binderShareQuoted: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertContractPayloadDto
     */
    binderShareSigned?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertContractPayloadDto
     */
    underwriter?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertContractPayloadDto
     */
    totalTiv?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertContractPayloadDto
     */
    rateMovement?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertContractPayloadDto
     */
    originalRate: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertContractPayloadDto
     */
    ntuReason?: UpsertContractPayloadDtoNtuReasonEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertContractPayloadDto
     */
    isDeclaration?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertContractPayloadDto
     */
    basisOfCover?: UpsertContractPayloadDtoBasisOfCoverEnum;
}


/**
 * @export
 */
export const UpsertContractPayloadDtoNtuReasonEnum = {
    Price: 'NTU - Price',
    Unsuccessful: 'NTU - Unsuccessful',
    NoResponse: 'NTU - No response',
    Other: 'NTU - Other'
} as const;
export type UpsertContractPayloadDtoNtuReasonEnum = typeof UpsertContractPayloadDtoNtuReasonEnum[keyof typeof UpsertContractPayloadDtoNtuReasonEnum];

/**
 * @export
 */
export const UpsertContractPayloadDtoBasisOfCoverEnum = {
    AnyOneEvent: 'Any One Event',
    AnyOneLocation: 'Any One Location',
    InTheAggregate: 'In the Aggregate'
} as const;
export type UpsertContractPayloadDtoBasisOfCoverEnum = typeof UpsertContractPayloadDtoBasisOfCoverEnum[keyof typeof UpsertContractPayloadDtoBasisOfCoverEnum];


/**
 * Check if a given object implements the UpsertContractPayloadDto interface.
 */
export function instanceOfUpsertContractPayloadDto(value: object): value is UpsertContractPayloadDto {
    if (!('binderId' in value) || value['binderId'] === undefined) return false;
    if (!('submissionId' in value) || value['submissionId'] === undefined) return false;
    if (!('layerId' in value) || value['layerId'] === undefined) return false;
    if (!('reinsuredId' in value) || value['reinsuredId'] === undefined) return false;
    if (!('brokerId' in value) || value['brokerId'] === undefined) return false;
    if (!('binderShareQuoted' in value) || value['binderShareQuoted'] === undefined) return false;
    if (!('originalRate' in value) || value['originalRate'] === undefined) return false;
    return true;
}

export function UpsertContractPayloadDtoFromJSON(json: any): UpsertContractPayloadDto {
    return UpsertContractPayloadDtoFromJSONTyped(json, false);
}

export function UpsertContractPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertContractPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'contractId': json['contractId'] == null ? undefined : json['contractId'],
        'binderId': json['binderId'],
        'submissionId': json['submissionId'],
        'layerId': json['layerId'],
        'reinsuredId': json['reinsuredId'],
        'brokerId': json['brokerId'],
        'binderShareQuoted': json['binderShareQuoted'],
        'binderShareSigned': json['binderShareSigned'] == null ? undefined : json['binderShareSigned'],
        'underwriter': json['underwriter'] == null ? undefined : json['underwriter'],
        'totalTiv': json['totalTiv'] == null ? undefined : json['totalTiv'],
        'rateMovement': json['rateMovement'] == null ? undefined : json['rateMovement'],
        'originalRate': json['originalRate'],
        'ntuReason': json['ntuReason'] == null ? undefined : json['ntuReason'],
        'isDeclaration': json['isDeclaration'] == null ? undefined : json['isDeclaration'],
        'basisOfCover': json['basisOfCover'] == null ? undefined : json['basisOfCover'],
    };
}

export function UpsertContractPayloadDtoToJSON(json: any): UpsertContractPayloadDto {
    return UpsertContractPayloadDtoToJSONTyped(json, false);
}

export function UpsertContractPayloadDtoToJSONTyped(value?: UpsertContractPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contractId': value['contractId'],
        'binderId': value['binderId'],
        'submissionId': value['submissionId'],
        'layerId': value['layerId'],
        'reinsuredId': value['reinsuredId'],
        'brokerId': value['brokerId'],
        'binderShareQuoted': value['binderShareQuoted'],
        'binderShareSigned': value['binderShareSigned'],
        'underwriter': value['underwriter'],
        'totalTiv': value['totalTiv'],
        'rateMovement': value['rateMovement'],
        'originalRate': value['originalRate'],
        'ntuReason': value['ntuReason'],
        'isDeclaration': value['isDeclaration'],
        'basisOfCover': value['basisOfCover'],
    };
}

